/**
 * Page Loading Component
 * Used as fallback for lazy-loaded route components
 */
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

export function PageLoading() {
  const { t } = useTranslation('common');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: 300,
      }}
    >
      <Spin size="large" tip={t('labels.loading')} />
    </div>
  );
}
